import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Button, Tooltip } from "antd";
import { Info } from "assets/icons";
import { bindActionCreators } from "redux";
import { Creators } from "store/multiple-realms/multiple-realms-duck";
import Cookies from "universal-cookie";
import { getUrlKeyClock } from "utils/auth/config";
import YmsNotification from "utils/functions/notification";
import useTranslation from "utils/hooks/useTranslation";
import { ContainerButtons, SSOContainer, SSOContainerButtonsContainer, SSOContainerTitle } from "./styles/styled";

interface IPropsScreenMultipleRealms {
  isLoading?: boolean;
}

interface IDispatchProps {
  toggleUnregisteredOpen: () => void;
}

export type IPropsMultipleRealmsPage = IPropsScreenMultipleRealms & IDispatchProps;

const SSOLogin = ({ isLoading, toggleUnregisteredOpen }: IPropsMultipleRealmsPage) => {
  const SIGNIN = useTranslation({ id: "signin" });
  const UNREGISTERED_USER_MESSAGE_ERROR = useTranslation({ id: "unregistered_user_register_below" });
  const INACTIVE_USER_MESSAGE_ERROR = useTranslation({ id: "inactive_user_access_blocked" });
  const SSO_LOGIN_MESSAGE_INFORMATION = useTranslation({ id: "sso_login_message_information" });
  const LOGIN_WITH_YOUR_CREDENTIALS = useTranslation({ id: "login_with_your_credentials" });
  const SSO_AMBEV = useTranslation({ id: "sso_ambev" });
  const FIRST_ACCESS = useTranslation({ id: "first_access" });

  const redirectTo = (url) => {
    window.location.href = url;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("error") === "unregistered") {
      YmsNotification({
        type: "error",
        description: UNREGISTERED_USER_MESSAGE_ERROR,
      });
    }
    if (params.get("error") === "inactive") {
      YmsNotification({
        type: "error",
        description: INACTIVE_USER_MESSAGE_ERROR,
      });
    }
  }, []);

  const setRealmName = (realmName) => {
    const cookies = new Cookies();
    cookies.set("ssoRealmName", realmName, { path: "/" });
  };

  const onClickAmbev = () => async () => {
    setRealmName("Ambev");
    const urlRedirect = await getUrlKeyClock();
    redirectTo(urlRedirect);
  };

  return (
    <SSOContainer>
      <SSOContainerTitle>
        <div>
          <span className="sso-title">{SIGNIN}</span>
          <Tooltip placement="top" title={SSO_LOGIN_MESSAGE_INFORMATION}>
            <Info />
          </Tooltip>
        </div>
        <span className="sso-subtitle">{LOGIN_WITH_YOUR_CREDENTIALS}</span>
      </SSOContainerTitle>
      <ContainerButtons>
        <SSOContainerButtonsContainer>
          <Button className="primaryButton" type="primary" htmlType="submit" size="large" onClick={onClickAmbev()} data-testid="sso_login" disabled={isLoading}>
            {SSO_AMBEV}
          </Button>
        </SSOContainerButtonsContainer>
        <SSOContainerButtonsContainer>
          <Button className="secondaryButton" htmlType="submit" size="large" onClick={toggleUnregisteredOpen} data-testid="first_access">
            {FIRST_ACCESS}
          </Button>
        </SSOContainerButtonsContainer>
      </ContainerButtons>
    </SSOContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.MultipleRealms.isLoading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(Creators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SSOLogin);
